import * as Styled from './styles';
import { HamburgerProps } from './types';

const Hamburger = ({ id, onClick, className }: HamburgerProps): JSX.Element => (
  <Styled.Hamburger id={id} onClick={onClick} className={className}>
    <div />
    <div />
    <div />
  </Styled.Hamburger>
);

export default Hamburger;
